import firebase from 'firebase/compat/app';
import React, { useEffect } from 'react';
import {
    Redirect,
    Route,
    Switch,
    useHistory,
    useLocation
} from 'react-router-dom';

import CreateIntroSlide from './CreateIntroSlide';
import Login from './Login';

export default function LoginRoutes(props: {
    user: firebase.User | null | undefined;
}) {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        // Store redirect parameter in session storage when accessing signup pages
        const searchParams = new URLSearchParams(location.search);
        const redirectParam = searchParams.get('redirect');

        if (
            redirectParam &&
            (location.pathname.includes('/signup/') ||
                location.pathname.includes('/login'))
        ) {
            sessionStorage.setItem('postLoginRedirect', redirectParam);
        }
    }, [location]);

    useEffect(() => {
        // Check for post-login redirect when user becomes authenticated
        // Only redirect immediately for login, not signup (let signup complete profile)
        if (props.user) {
            const redirectPath = sessionStorage.getItem('postLoginRedirect');
            const isSignupFlow = location.pathname.includes('/signup/');

            // Only redirect immediately if this is a login flow, not signup
            if (redirectPath && !isSignupFlow) {
                sessionStorage.removeItem('postLoginRedirect');
                // Small delay to ensure user context is loaded
                setTimeout(() => {
                    history.push(redirectPath);
                }, 100);
            }
        }
    }, [props.user, history, location.pathname]);
    return (
        <Switch>
            <Route exact path={['/signup/select']}>
                <CreateIntroSlide />
            </Route>
            <Route exact path={['/signup/user', '/signup/user/:uid']}>
                {props.user ? (
                    <Redirect to={`/create/${props.user.uid}/candidate/name`} /> // handle scenario where existing user is logging in
                ) : (
                    <Login />
                )}
            </Route>
            <Route exact path={['/signup/business', '/signup/business/:uid']}>
                {props.user ? (
                    <Redirect to={`/create/${props.user.uid}/business/jumpstart`} />
                ) : (
                    <Login />
                )}
            </Route>
            <Route exact path={['/', '/login', '/resetpassword']}>
                {props.user && (
                    <Redirect to={`/secure/${props.user.uid}/dashboard`} />
                )}
                {props.user === null && <Login />}
            </Route>
        </Switch>
    );
}
